export const deviceIsMobile = () => {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /BB/i,
        /PlayBook/i,
        /Kindle/i,
        /Silk/i,
        /Windows Phone/i,
        /MacIntel/i,
        /Opera Mini/i,
        /IEMobile/i,
        /WPDesktop/i,
        /Mobi/i

    ];
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
};